import { Chip, FormControl, FormHelperText, Grid, Input, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import CancelIcon from '@material-ui/icons/Cancel';
import Autocomplete from '@material-ui/lab/Autocomplete';

function RuleItem(props) {
    const theme = useTheme();

    const handleTypeChange = (e) => {
        if (props.onRuleChange) {
            props.onRuleChange(props.index, {...props.Rule, TypeID: e.target.value, Values: []})
        }
    }

    const handleValueChange = (e) => {
        let newValues = e.target.value;
        if (typeof newValues === 'string') {
            newValues = newValues.split(",");
        }
        if (props.onRuleChange) {
            props.onRuleChange(props.index, {...props.Rule, Values: newValues})
        }
    }

    const handleAutocompleteChange = (e, val) => {
        //loop over the array of label, get the ids, put them in an array
        //set the value
        let v = val.map(i => {
            return i.ID + "";
        })
        console.log(v)
        if (props.onRuleChange) {
            props.onRuleChange(props.index, {...props.Rule, Values: v})
        }
    }

    const getDefaultValues = () => {
        //returns an array of default values that are selected
        let arr = props.Rule.Values;
        if (typeof arr === 'string') {
            arr = arr.split(",")
        }
        //with the array, pull out all the objects that we need
        let defaults = [];
        arr.forEach(v => {
            //find the leadsource
            let ls = props.leadSources.find(ls => {
                return ls.ID === parseInt(v)
            })
            if (ls) {
                defaults.push(ls)
            }
        })
        return defaults;
    }

    const formatRuleValues = (toArray) => {
        console.log('values are ' + JSON.stringify(props.Rule.Values))
        if (typeof props.Rule.Values === 'string' && toArray) {
            return props.Rule.Values.split(",")
        }
        if (typeof props.Rule.Values === 'object' && !toArray) {
            return props.Rule.Values.join(',')
        }
        return props.Rule.Values;
    }

    const handleRemove = () => {
        if (props.onRuleRemove) {
            props.onRuleRemove(props.index);
        }
    }

    return (
        <>
            <Grid container style={{borderTop: "1px solid grey", marginBottom: "10px", paddingTop: "5px", alignItems: "center"}}>
                <Grid item xs={1}>
                    {props.index + 1}
                </Grid>
                <Grid item xs={3}>
                    <FormControl>
                    <InputLabel id="demo-simple-select-helper-label">Rule Type</InputLabel>
                        <Select
                        value={props.Rule.TypeID}
                        onChange={handleTypeChange}
                        >
                            <MenuItem value={0}>
                                <em>Please Select a Type</em>
                            </MenuItem>
                            {
                                props.ruleTypes.map(rt => {
                                    return (
                                        <MenuItem key={`rule-type-select-${rt.Name}`} value={rt.ID}>{rt.Name}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    <FormHelperText>The field to check</FormHelperText>
                </FormControl>
                </Grid>
                <Grid item xs={7}>
                    {
                        props.Rule.TypeID == 1 && <FormControl style={{width: "85%"}}>
                            <InputLabel >Sales Area</InputLabel>
                            <Select
                            multiple
                            value={formatRuleValues(true)}
                            onChange={handleValueChange}
                            input={<Input id="select-multiple-chip" />}
                            renderValue={(selected) => {
                                return(
                                <div>
                                {selected && selected.map((value) => {
                                    var sa = props.salesAreas.find(s => s.ID === parseInt(value))
                                    return sa ? (
                                        <Chip key={value} label={sa.Label} />
                                    ) : null;
                                })}
                                </div>
                                )}}
                            >
                            {props.salesAreas.map((sa) => {
                                return (
                                    <MenuItem key={sa.Label} value={sa.ID + ""} style={getStyles(sa.ID, props.Rule.Values, theme)} >
                                        {sa.Label}
                                    </MenuItem>
                                )
                            })}
                            </Select>
                        </FormControl>
                    }
                    {
                        props.Rule.TypeID == 2 && <Autocomplete
                            multiple
                            style={{width: "80%"}}
                            options={props.leadSources}
                            onChange={handleAutocompleteChange}
                            getOptionLabel={(option) => option.Label}
                            defaultValue={getDefaultValues}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                label="Lead Sources"
                                placeholder="Select"
                            />
                            )}
                        />
                    }
                    {
                        props.Rule.TypeID == 3 && <TextField style={{width:"80%"}} value={formatRuleValues(false)} onChange={handleValueChange} label="Search Values" helperText="Comma Separated list of numbers" />
                    }
                    {
                        props.Rule.TypeID == 4 && <div>
                            <span>Is After</span>
                            <FormControl style={{width: "85%"}}>
                                <InputLabel >Timeframe</InputLabel>
                                <Select
                                value={formatRuleValues(true)}
                                onChange={handleValueChange}
                                input={<Input id="timeframe-select" />}
                                >
                                    <MenuItem value={'1'} >
                                        Yesterday
                                    </MenuItem>
                                    <MenuItem value={'7'} >
                                        7 Days
                                    </MenuItem>
                                    <MenuItem value={'30'} >
                                        30 Days
                                    </MenuItem>
                                    <MenuItem value={'90'} >
                                        90 Days
                                    </MenuItem>
                                    <MenuItem value={'120'} >
                                        120 Days
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    }
                </Grid>
                <Grid item xs={1}>
                    <CancelIcon onClick={handleRemove} style={{color: "var(--color-orange", cursor: "pointer"}} />
                </Grid>
            </Grid>
        </>
    )
}

export default RuleItem;

function getStyles(name, personName, theme) {
    return {
        fontWeight:
        personName.indexOf(name) === -1
            ? theme.typography.fontWeightRegular
            : theme.typography.fontWeightMedium,
    };
}